export interface Scheme {
  id: string;
  category: string;
  title: string;
  description: string;
  eligibility: string;
  procedure: string;
  benefits: string;
  officialLink: string;
  launchDate?: Date;
  lastUpdated?: Date;
  isActive: boolean;
  priority: number;
  stateAvailability: string[];
  isNew: boolean;
  _rawTitleMap?: Record<string, string>;
  _rawDescriptionMap?: Record<string, string>;
  _rawEligibilityMap?: Record<string, string>;
  _rawProcedureMap?: Record<string, string>;
  _rawBenefitsMap?: Record<string, string>;
}

export const getLocalizedTitle = (scheme: Scheme, lang: string): string => {
  const localized = scheme._rawTitleMap?.[lang] || scheme.title;
  return String(localized || '');
};

export const getLocalizedDescription = (scheme: Scheme, lang: string): string => {
  const localized = scheme._rawDescriptionMap?.[lang] || scheme.description;
  return String(localized || '');
};

export const getLocalizedEligibility = (scheme: Scheme, lang: string): string => {
  const localized = scheme._rawEligibilityMap?.[lang] || scheme.eligibility;
  return String(localized || '');
};

export const getLocalizedProcedure = (scheme: Scheme, lang: string): string => {
  const localized = scheme._rawProcedureMap?.[lang] || scheme.procedure;
  return String(localized || '');
};

export const getLocalizedBenefits = (scheme: Scheme, lang: string): string => {
  const localized = scheme._rawBenefitsMap?.[lang] || scheme.benefits;
  return String(localized || '');
};

export const isAvailableInState = (scheme: Scheme, state: string): boolean => {
  // Handle 'all' state
  if (state.toLowerCase() === 'all') {
    return true;
  }
  
  // Ensure stateAvailability is an array
  if (!Array.isArray(scheme.stateAvailability) || scheme.stateAvailability.length === 0) {
    return false;
  }
  
  // Normalize to lowercase for comparison
  const normalizedState = state.toLowerCase().trim();
  return scheme.stateAvailability.some(
    (s) => s.toLowerCase().trim() === normalizedState || s.toLowerCase().trim() === 'all'
  );
};
